import * as types from '../actions/actionTypes';
import initialState from './initialState';


export default function courseReducer(state = initialState.course, action) {
    switch (action.type) {
        case types.GET_COURSE_SUCCESS:
            return action.course;
        case types.RESET_COURSE:
            return {...initialState.course};
        case types.GET_ADDRESS_DETAILS_SUCCESS:
            return {
                ...state,
                location: {
                    ...state.location,
                    postalCode: action.addressDetails.adgangsadresse.postnummer.nr,
                    city: action.addressDetails.adgangsadresse.postnummer.navn,
                    latitude: action.addressDetails.adgangsadresse.adgangspunkt.koordinater[1],
                    longitude: action.addressDetails.adgangsadresse.adgangspunkt.koordinater[0],
                }
            };
        case types.UPDATE_SELECTED_REGION_ID:
            return {
                ...state,
                location: {
                    ...state.location,
                    regionId: action.regionId
                }
            };
        case types.CLEAR_CITY_INFORMATION:
            return {
                ...state,
                location: {
                    ...state.location,
                    city: '',
                    postalCode: '',
                    addressId: '',
                    latitude: '',
                    longitude: ''
                }
            };
        case types.UPDATE_SELECTED_MUNICIPALITY_ID:
            return {
                ...state,
                location: {
                    ...state.location,
                    municipalityId: action.municipalityId
                }
            };
        case types.UPDATE_SELECTED_ADDRESS_ID:
            return {
                ...state,
                location: {
                    ...state.location,
                    addressId: action.addressId
                }
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./web/src/reducers/courseReducer.js